import React from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { MessageCard } from "@features/Messages/components/MessageCard/MessageCard";
import { MessageSkeleton } from "@features/skeletons/Messages/MessagesSkeleton/components/MessageSkeleton/MessageSkeleton";
import { MessagesListSkeleton } from "@features/skeletons/Messages/MessagesSkeleton/components/MessagesListSkeleton/MessagesListSkeleton";

export const MessagesSkeleton: React.FC = () => {
  const { id } = useParams();

  return (
    <div className="flex flex-col gap-6 md:h-[calc(100dvh_-_210px)] md:max-h-[calc(100dvh_-_210px)] md:flex-1 md:flex-row md:overflow-auto">
      <div
        className={twMerge(
          "md:w-full md:max-w-[280px]",
          id && "hidden md:block",
        )}
      >
        <MessageCard className="overflow-hidden md:overflow-y-auto">
          <MessagesListSkeleton />
        </MessageCard>
      </div>
      <div className={twMerge("hidden w-full md:block", id && "block")}>
        <MessageCard className="md:border-b-1 min-h-52 h-auto border-b-0 shadow-none md:overflow-hidden md:shadow-sm">
          <MessageSkeleton />
        </MessageCard>
      </div>
    </div>
  );
};
